/**
 * PropertyStatusBadge Component
 *
 * Consistent badge styling for property status across the application.
 * Uses centralized configuration from badgeConfig.js to ensure consistency.
 */

import React from "react";
import { Badge } from "../Badge";
import PropTypes from "prop-types";
import { getPropertyStatusConfig } from "../../../tools/properties/badgeConfig";
import "./PropertyStatusBadge.scss";

export const PropertyStatusBadge = ({
  status,
  size = "medium",
  showIcon = false,
  className = "",
  count = null,
}) => {
  if (!status) return null;

  // Extract actual status if it has a count prefix (e.g., "2 Sold STC" -> "Sold STC")
  const actualStatus = status.replace(/^\d+\s+/, "");
  const config = getPropertyStatusConfig(actualStatus);
  const Icon = showIcon && config.icon ? config.icon : null;

  // Use count prop if provided, otherwise check if status has count prefix
  const displayLabel = count !== null ? `${count} ${config.label}` : status;

  return (
    <Badge
      variant={config.variant}
      size={size}
      className={`property-status-badge ${className}`}
    >
      {Icon && <Icon style={{ marginRight: "0.25rem" }} />}
      {displayLabel}
    </Badge>
  );
};

PropertyStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  showIcon: PropTypes.bool,
  className: PropTypes.string,
  count: PropTypes.number,
};

export default PropertyStatusBadge;
